var map = {
	"./pic1.jpg": 56,
	"./pic10.jpg": 57,
	"./pic11.jpg": 58,
	"./pic12.jpg": 59,
	"./pic13.jpg": 60,
	"./pic14.jpg": 61,
	"./pic15.jpg": 62,
	"./pic16.jpg": 63,
	"./pic17.jpg": 64,
	"./pic18.jpg": 65,
	"./pic19.jpg": 66,
	"./pic2.jpg": 67,
	"./pic20.jpg": 68,
	"./pic21.jpg": 69,
	"./pic22.jpg": 70,
	"./pic3.jpg": 71,
	"./pic4.jpg": 72,
	"./pic5.jpg": 73,
	"./pic6.jpg": 74,
	"./pic7.jpg": 75,
	"./pic8.jpg": 76,
	"./pic9.jpg": 77
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55;